import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Lock, Loader2 } from "lucide-react";

export default function AdminLogin() {
  const { user, login, loading } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-[#1F2547]">
        Loading…
      </div>
    );
  }

  if (user) {
    return <Navigate to="/admin" replace />;
  }

  async function submit(e) {
    e.preventDefault();
    setErr("");
    setBusy(true);
    const res = await login(email, password);
    setBusy(false);
    if (res.ok) nav("/admin");
    else setErr(res.error || "Login failed");
  }

  return (
    <main
      data-testid="admin-login-page"
      className="min-h-screen flex items-center justify-center bg-[#F7F6FB] px-6"
    >
      <form
        onSubmit={submit}
        className="w-full max-w-md bg-white rounded-3xl brutal-shadow-lg p-8 md:p-10"
      >
        <div className="w-12 h-12 rounded-2xl bg-[#9F87D8] text-white flex items-center justify-center mb-5">
          <Lock className="w-5 h-5" />
        </div>
        <h1 className="font-display text-3xl font-black tracking-tight text-[#1F2547]">
          Admin sign in
        </h1>
        <p className="text-sm text-[#5B6079] mt-1 font-medium">
          Percept Academy management console
        </p>

        <div className="mt-6 space-y-3">
          <label className="block text-xs font-bold uppercase tracking-[0.18em] text-[#5B6079]">
            Email
          </label>
          <input
            data-testid="login-email-input"
            type="email"
            autoComplete="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-4 py-3 rounded-xl border border-[#1F2547]/15 focus:outline-none focus:border-[#9F87D8] text-[#1F2547] font-medium"
            placeholder="you@example.com"
          />

          <label className="block text-xs font-bold uppercase tracking-[0.18em] text-[#5B6079] mt-3">
            Password
          </label>
          <input
            data-testid="login-password-input"
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-4 py-3 rounded-xl border border-[#1F2547]/15 focus:outline-none focus:border-[#9F87D8] text-[#1F2547] font-medium"
            placeholder="••••••••"
          />
        </div>

        {err && (
          <div
            data-testid="login-error"
            className="mt-4 text-sm text-red-700 bg-red-50 border border-red-200 rounded-xl px-3 py-2 font-medium"
          >
            {err}
          </div>
        )}

        <button
          data-testid="login-submit-btn"
          type="submit"
          disabled={busy}
          className="mt-6 w-full inline-flex items-center justify-center gap-2 px-5 py-3 bg-[#9F87D8] text-white font-bold rounded-full brutal-shadow btn-press disabled:opacity-60"
        >
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : null}
          Sign in
        </button>

        <p className="mt-6 text-xs text-[#5B6079] font-medium">
          Forgot password? Contact your administrator.
        </p>
      </form>
    </main>
  );
}
